import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
import { toast } from 'react-toastify';
import CustomSelectInput from './dropDown/CustomSelectInput';
import TableLoader from './TableLoader';
import GlobalFooter from './GlobalFooter';

function YapilyCrendential() {
    const [isProcessing,setIsProcessing] = useState(false)
    const [isCountry,setIsCountry] = useState(false)
    const [selectedOption,setSelectedOption] = useState(null)
    const record = JSON.parse(localStorage.getItem("auth"))
    const navigate = useNavigate()
    const [isLoading,setIsLoading] = useState(false)
    const [formData, setFormData] = useState({
        countryCode: '',
    });
    const [countryData,setCountryData] = useState([])

    const handleClose = ()=>{
        // navigate("/pages/global-payment")
    }

    useEffect(()=>{
        loadCountry()
    },[])
    const currency = record.data?.cbInfo?.currency_collected

    const [error,setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    
    const handleChange = (e) => {
        const { name, value } = e.target;
        let updatedValue = value;

        if (name === 'phoneNumber') {
            // Check for leading zero
            if (value.startsWith('0')) {
                setErrorMessage('Phone number should not start with 0');
                
                // Automatically hide error after 3 seconds
                setTimeout(() => {
                    setErrorMessage('');
                }, 2000);
            }

            // Remove leading zeros
            updatedValue = value.replace(/^0+/, '');
        }
        setFormData({
            ...formData,
            [name]: updatedValue
        });
    };

    const loadCountry = async()=>{
        setIsProcessing(true)
        try{
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/get-countries"
            const res = await axios.get(url)
            setIsProcessing(false);
            // console.log("result: ",res?.data.data)
            const data = res.data.data
            setCountryData(data);
        }catch(err){
            setIsProcessing(false)
            toast.error("Service not available; Please try again!")
            setTimeout(()=>{
                navigate('/invalid')
            },3000)
        }
    }

    const handleSubmit = async(e)=>{
        e.preventDefault();
        
        // let url="";
        // let payload={

        // }

        // if( currency==="GBP" || selectedOption?.code === "DE"){
        //     setIsLoading(true);
        //     url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/global-payment/europe/initiate-transfer"
        //     payload = {
        //     currency:currency,
        //     countryCode:selectedOption?.code || "GB",
        //     amount:`${record?.data?.amount}`,
        //     transactionId:record?.data?.transactionId
        //     }

        //     try{
        //     const res = await axios.post(url,payload)
        //     const {hostedUrl} = res.data?.data?.data || ''
        //     if(hostedUrl){
        //         setIsLoading(false)
        //         window.location.href = hostedUrl;
        //     }
               
    
        //     }catch(err){
        //         setIsLoading(false)
        //         setError(true)
        //         console.log("error",err)
        //         const errorMessage = err.response?.data?.message || "An Unexpected error has occured: try again"
        //         toast.error(errorMessage)
        //     }
             
        // }else {

        //     if(!selectedOption?.code) return toast("Country is required")
        //     let countryCode = selectedOption?.code
        //     localStorage.setItem("countryCode",countryCode)
        //     return navigate('/pages/payment-account')
        // }
        if(!selectedOption?.code && currency !=="GBP") return toast("Country is required")
        let countryCode=""
        if(currency === "GBP"){
             countryCode = "GB"
        }else{
            // countryCode = formData.countryCode
            countryCode = selectedOption?.code
        }
        // let countryCode = selectedOption?.code
        localStorage.setItem("countryCode",countryCode)
        console.log("code: ",countryCode);
        return navigate('/pages/payment-account')

    }
    // const isPhoneNumberEntered = formData.phoneNumber.trim().length > 0;
    const handleCountry = ()=>{
        setIsCountry(!isCountry)
    }

    const handleSelectedOption =(option)=>{
        setSelectedOption(option)
        handleCountry()
    }

    const handleModalClose = ()=>{
        if (isCountry) {
            setIsCountry(false); // Only close the modal if it’s open
        }
    }
    
  return (
    <div className='global_layout' onClick={handleModalClose}>
    
        <div className='global_container'>
            <div className='top_bar'>
                {/* <img src='/images/global/arrow-left.svg' alt='' onClick={handleClose}/> */}
                <img src='/images/global/close.svg' alt='' onClick={handleClose} style={{marginLeft:"auto"}}/>
            </div>

            <div className='global_content' onClick={(e) => e.stopPropagation()}>
                <div className='glob_avater'>
                        {
                            record?.avatar ?
                            
                            <img className='img_avater' src={record?.avatar} alt='' />:  
                            <p className='glob_avater_text'>{String(record?.data?.business_name).slice(0,1)}</p>
                        }
                </div>
                <p className='glob_title'>Payment information</p>
                <p className='glob_desc'>Your data is encrypted and your details will not be accessible to Superwallet</p>
                <div className='amount_content'>
                    <div className='name_amount'>
                        <img src='/images/global/briefcase.svg' alt=''/> 
                        <p className='glob_name'>Name</p>
                    </div>
                    <h6 className='name_value'>{record?.data?.business_name}</h6>
                </div>
                <div className='amount_pattern'>
                    <p className='glob_name' style={{marginTop:"10px"}}>Amount</p>
                    <p className='glob_amount_value'>{record?.payableFxAmountString}</p>
                </div>
                {/* Phone Number */}
                
                    
                    <form className='glob_form' onSubmit={handleSubmit}>
                       {
                        currency !=="GBP" &&
                        <div className='phone_container'>
                            <div style={{display:"flex"}}>
                                <p className='glob_name'>Country</p>
                                <img src='/images/global/asterisk.svg' alt=''/>
                            </div>
                            
                            <div>
                                <div className='select_phone_yapil' onClick={handleCountry}>
                                    {
                                        selectedOption ?
                                        <p className='customer_placeholder'>{selectedOption?.name}</p>:
                                        <p className='customer_placeholder'>Select a country</p>
                                    }
                                    <img src="/images/global/chevron-downs.svg" alt="" />
                                </div>
                                {
                                    isCountry &&
                                    <CustomSelectInput handleSelectedOption={handleSelectedOption}  selectedBank={selectedOption} data={countryData}/>
                                }
                            </div>
                            {/* input field */}
                                
                            
                            {/* Error message */}
                            {errorMessage && (
                                    <p className='error_msg' style={{ color: '#D92D20', marginTop: '5px' }}>{errorMessage}</p>
                            )}
                        </div>
                       }
                           
                        
                        {
                            !record?.total_whitelabelling &&
                            <>
                            <p className='instruction_text' style={{marginTop:"18px"}}>By selecting “Continue” you agree to the </p>
                            <h5 className='flick_privacy'>Flick End User Privacy Policy</h5>
                            </>
                        }
                        <button 
                        disabled={ isLoading}
                        className={`${isLoading ? 'unactive' : 'globalBtn'}`}
                    
                        style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px"}}
                        >
                            {isLoading ? (
                                <BeatLoader
                                    color="#FFF"
                                    cssOverride={{}}
                                />              ) : (
                                <>   
                                    <p>Proceed</p>
                                    {
                                        isLoading ?
                                        <img src='/images/global/inactive.svg' alt='' />:
                                        <img src='/images/global/activeArrow.svg' alt='' />
                                    }
                                </>
                            )}   
                        </button>
                    </form>
                
                

            </div>
        </div>
        {
            isProcessing &&
            <TableLoader />
        }
        {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default YapilyCrendential